export const iconNames = [
    'accessibility',
    'acorn',
    'apple',
    'archive',
    'attachment',
    'award-medal',
    'bell',
    'bold',
    'book',
    'book-open',
    'bookmark',
    'box',
    'box-fill',
    'bullet-list',
    'cal-empty',
    'cal-full',
    'calculator',
    'calendar-add',
    'calendar-save-the-date',
    'cart',
    'center-align',
    'chat',
    'check',
    'check-circle',
    'check-fill',
    'checkbox',
    'checklist',
    'circle',
    'clipboard',
    'clipboard-check',
    'code',
    'coin',
    'compose',
    'compose-cell',
    'compose-pen',
    'computer',
    'copy',
    'cut',
    'disc',
    'disc-alt',
    'document-award',
    'dollar',
    'down',
    'download',
    'download-alt',
    'east',
    'error',
    'exclamation',
    'exclamation-circle',
    'exclamation-fill',
    'exit-full-screen',
    'expand-window',
    'explore',
    'face-bad',
    'face-excellent',
    'face-good',
    'face-neutral',
    'face-very-bad',
    'facebook',
    'feedback',
    'filter',
    'financial-aid',
    'folder',
    'full-screen',
    'globe',
    'graduate',
    'graph',
    'heart',
    'home',
    'horz-grab-handle',
    'hyperlink',
    'image',
    'indent',
    'info',
    'info-circle',
    'info-page',
    'instagram',
    'italic',
    'khan-academy',
    'laptop',
    'laptop-exclamation',
    'layout-50-50',
    'layout-left-pane',
    'layout-right-pane',
    'left',
    'left-align',
    'left-double',
    'lightbulb',
    'linkedin',
    'list',
    'location',
    'location-pin',
    'location-tag',
    'lock',
    'lock-open',
    'logout',
    'mail',
    'math-essential',
    'megaphone',
    'menu',
    'microscope',
    'minus',
    'more',
    'more-alt',
    'new-page',
    'new-window',
    'north',
    'north-east',
    'north-west',
    'note',
    'notepad-check',
    'number-list',
    'omega',
    'order-asc',
    'order-desc',
    'pages',
    'paper-airplane',
    'paste',
    'pause',
    'pause-circle',
    'pending',
    'phone',
    'pi',
    'play',
    'play-circle',
    'plus',
    'practice',
    'practice-test',
    'print',
    'question',
    'question-circle',
    'question-fill',
    'quotes',
    'raised-pencil',
    'redo',
    'refresh',
    'right',
    'right-align',
    'right-double',
    'sat',
    'save',
    'school',
    'school-urban',
    'search',
    'see-off',
    'see-on',
    'send-scores',
    'settings',
    'share',
    'share-alt',
    'share-arrow',
    'sort',
    'sort-asc',
    'sort-desc',
    'south',
    'stop',
    'stopwatch',
    'submit',
    'subscript',
    'superscript',
    'table-ico',
    'tablet',
    'tag',
    'task-complete',
    'teacher',
    'team-leader',
    'text-style-off',
    'tool',
    'trash',
    'trophy',
    'twitter',
    'underline',
    'undo',
    'university',
    'up',
    'upload',
    'user',
    'user-add',
    'user-circle',
    'user-remove',
    'vert-grab-handle',
    'west',
    'window',
    'x-mark',
    'youtube',
];
//# sourceMappingURL=IconName.js.map